import SummerHearts from '../assets/fonts/SummerHearts-Regular.otf'
import Interstate from '../assets/fonts/Interstate-LightCondensed.otf'

const LabsTheme = {
    /* Basic Sizing */
    element_margin: '1.5em',
    /* Fonts */
    font_header: 'Montserrat',
    font_subheader: 'Montserrat',
    font_body: 'Montserrat',
    font_weight_standard: 300,
    font_weight_bold: 700,
    /* Colors */
    bg_dark: 'black',
    bg_light: 'white',
    bg_body: 'white',
    font_light: 'white',
    font_dark: 'black',
    accent: '#f52213',
}
const TreblekeyTheme = {
    /* Basic Sizing */
    element_margin: '1.5em',
    /* Fonts */
    font_header: 'Teko',
    font_subheader: 'Teko',
    font_body: 'Helvetica',
    font_weight_standard: 300,
    font_weight_bold: 500,
    /* Colors */
    bg_dark: '#282829',
    bg_light: '#F1EFE9',
    bg_body: 'white',
    font_light: '#E6D9C3',
    font_dark: '#282829',
    accent: '#af8e58',
}
const HarvestTheme = {
    /* Basic Sizing */
    element_margin: '1.5em',
    /* Fonts */
    font_header: 'SummerHearts',
    font_subheader: 'InterstateBold',
    font_body: 'Interstate',
    font_weight_standard: 300,
    font_weight_bold: 500,
    /* Colors */
    bg_dark: '#FFFFFF',
    bg_light: '#FADE21',
    font_light: '#000000',
    font_dark: '#FFFFFF',
    bg_body: 'white',
    accent: '#FADE21',
}
const HyperstateTheme = {
    /* Basic Sizing */
    element_margin: '1em',
    /* Fonts */
    font_header: 'Orator',
    font_subheader: 'Roboto',
    font_body: 'Roboto',
    font_weight_standard: 300,
    font_weight_bold: 500,
    /* Colors */
    bg_dark: '#1A61F3',
    bg_light: '#FFFFFF',
    bg_body: '#1A61F3',
    font_light: '#FFFFFF',
    font_dark: '#1A61F3',
    accent: '#44E49B',
}

export { LabsTheme, TreblekeyTheme, HarvestTheme, HyperstateTheme }


// WEBPACK FOOTER //
// ./src/components/theme.js